import { Link } from "react-router-dom";

/**
 * SiteFooter — small legal footer rendered at the bottom of every page.
 * Variants:
 *   - "dashboard" (default): inside the auth'd app — minimal text, fits under main content
 *   - "marketing": for the public landing/about pages — wider, brand-aligned
 *   - "minimal": for auth screens (login/register) — single line, centred
 */
// Registered business identity (used in footer + legal pages)
export const BUSINESS = {
  legalName: "Oz Tech Hub",
  brand: "RankPilot AI",
  address: "17 Selma Walk, Donnybrook, VIC 3064, Australia",
  phone: "+61 413 227 784",
  email: "support@myrankpilotai.com",
  country: "Australia",
};

export default function SiteFooter({ variant = "dashboard" }) {
  const year = new Date().getFullYear();

  const links = (
    <>
      <Link to="/privacy" className="hover:text-zinc-300 transition-colors" data-testid="footer-privacy">Privacy Policy</Link>
      <span className="text-zinc-700">·</span>
      <Link to="/terms" className="hover:text-zinc-300 transition-colors" data-testid="footer-terms">Terms of Service</Link>
      <span className="text-zinc-700">·</span>
      <Link to="/about" className="hover:text-zinc-300 transition-colors" data-testid="footer-about">About</Link>
      <span className="text-zinc-700">·</span>
      <a href={`mailto:${BUSINESS.email}`} className="hover:text-zinc-300 transition-colors" data-testid="footer-contact">Contact</a>
    </>
  );

  const businessLine = (
    <span className="text-zinc-600" data-testid="footer-business">
      {BUSINESS.legalName} · {BUSINESS.address} · {BUSINESS.phone}
    </span>
  );

  if (variant === "minimal") {
    return (
      <footer className="text-center text-xs text-zinc-600 py-6 flex flex-col items-center justify-center gap-2" data-testid="site-footer-minimal">
        <div className="flex flex-wrap items-center justify-center gap-2">
          <span>© {year} {BUSINESS.brand}</span>
          <span className="text-zinc-700">·</span>
          {links}
        </div>
        {businessLine}
      </footer>
    );
  }

  if (variant === "marketing") {
    return (
      <div className="border-t border-zinc-800/80 mt-8 pt-6 flex flex-col gap-3 text-xs text-zinc-500" data-testid="site-footer-marketing">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <span>© {year} {BUSINESS.brand}. All rights reserved.</span>
          <div className="flex flex-wrap items-center gap-2">
            {links}
          </div>
        </div>
        {businessLine}
      </div>
    );
  }

  // dashboard (default)
  return (
    <footer className="mt-16 pt-6 border-t border-zinc-800/60 flex flex-col gap-3 text-xs text-zinc-500" data-testid="site-footer">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <span>© {year} {BUSINESS.brand}</span>
        <div className="flex flex-wrap items-center gap-2">
          {links}
        </div>
      </div>
      {businessLine}
    </footer>
  );
}
